// /**
//  * Create and Edit Order
//  */

import React, { useState, useEffect, useContext, useRef } from 'react'
import { useLocation } from 'react-router-dom'

// components
import { useForm } from 'react-hook-form'
import { isEmpty } from 'lodash'
// UI
import {
  Grid,
  Button,
  Paper,
  Typography,
  DialogContent,
  IconButton,
  DialogActions,
  Dialog,
  CardHeader,
  CardContent,
  Card,
  Divider
} from '@material-ui/core'
import List from './components/list'
import jMoment from 'moment-jalaali'
import classes from './index.module.scss'

// Type
import {
  ParcelItems,
  PayloadCreate,
  SelectorProps
} from '../parcelsSender/interfaces'

// helpers'
import {
  removeEmptyValueObject,
  convertPersianDigit2English,
  checkHourisPast,
  disablePrevDateByHour
} from '../../utils/helpers'
import { createParcelsActions } from '../parcels/actions'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { createStructuredSelector } from 'reselect'
import { Store } from '../../redux/reducers'
import {
  makeSelectCountList,
  makeSelectError,
  makeSelectLoading
} from '../parcels/selectors'
import CustomerInfo from '../../components/sections/createOrder/customerInfo'

import { useHistory } from 'react-router-dom'
import handleNotification from '../../utils/handleNotfication'
import handleError from '../../utils/handleError'
import {
  clearOrderAction,
  createOrderItemsAction,
  getAllOrderItemsAction,
  getOrderWithIdAction,
  resendOrdersAction,
  updateOrderStatusActions
} from '../orders/actions'
import { makeSelectAllOrderItems, makeSelectOrder } from '../orders/selectors'
import {
  createOrderItemsPayload,
  Order,
  OrderItems,
  UpdateOrderPayload
} from '../orders/interfaces'
import AuthContext from '../../authContext'
import OrderResendInputs from '../../components/inputs/orderResendInputs'
import ordersRepository from 'client-sdk/src/Repository/orders-repository'
import FileWithLink from '../../components/inputs/fileWithLink'
import OrderResendInfo from '../../components/sections/createOrder/orderResendInfo'
import getOrderFileReq from 'client-sdk/src/orders/files'
import RonadIcons from '../../components/iconComponent'

jMoment.loadPersian({ dialect: 'persian-modern', usePersianDigits: true })

type Props = {
  create: (body: any) => void
  onClose: () => void
  warehouseId: number
  createParcelsDispatch: (payload: PayloadCreate) => void
  getOrderDispatch: (payload: { id: number }) => void
  orderItemsList?: OrderItems[]
  getOrderItemsDispatch: (payload: any) => void
  createOrderItemDispatch: (payload: createOrderItemsPayload) => void
  updateOrderDispatch: (payload: UpdateOrderPayload) => void
  clearOrderDispatch: () => void
  order: Order
  match: any
}

type Inputs = {
  agentName: string
  agentPhoneNumber: string
  deliveryDate: string | null
  destinationId: number
  orderType: string | null
  fulfillmentTypeId: number | null
  deliveryServiceId: number | null
  courierId: number | null
  cutoffId: number | null
  id: number
  origin: string | number
  destination: string
  customerName: string
  customerNationalCode: string
  customerMobileNumber: string
  customerPhoneNumber: string
  customerProvince: string
  customerCity: string
  customerZipCode: string
  deliveryType: string
  trackingCode: string
  customerAddress: string
  description: string
  items: ParcelItems[]
  deliveryTime: string | null
  deliveryStartTime: string | null
  deliveryEndTime: string | null
  returnStatus: string
  orderTplType: string
}

type Location = {
  lat: number
  lng: number
}

function ResendOrder(props: Props) {
  const history = useHistory()
  const authContext = useContext(AuthContext)
  const form = useForm<Inputs>({
    defaultValues: {
      orderType: '',
      deliveryDate: null,
      deliveryTime: '',
      deliveryStartTime: null,
      deliveryEndTime: null,
      fulfillmentTypeId: null,
      deliveryServiceId: null,
      courierId: null,
      cutoffId: null,
      origin: '',
      destination: '',
      customerName: '',
      customerNationalCode: '',
      customerMobileNumber: '',
      customerPhoneNumber: '',
      customerProvince: '',
      customerCity: '',
      customerZipCode: '',
      deliveryType: '',
      trackingCode: '',
      customerAddress: '',
      description: '',
      returnStatus: '',
      orderTplType: ''
    }
  })
  const {
    handleSubmit,
    errors,
    watch,
    setValue,
    getValues,
    register,
    control,
    reset
  } = form
  // Checkbox States
  const [deliveryLocationType, setDeliveryLocationType] =
    useState<boolean>(false)
  const [cod, setCod] = useState(false)
  const [isFulfillmentService, setIsFulfillmentService] = useState(false)

  const [invoiceLink, setInvoiceLink] = useState<any>('')
  const [invoiceFile, setInvoiceFile] = useState('')
  const [invoiceFileName, setInvoiceFileName] = useState('')
  const [labelLink, setLabelLink] = useState<any>('')
  const [labelFile, setLabelFile] = useState('')
  const [labelFileName, setLabelFileName] = useState('')
  const [notifType, setNotifType] = useState('')
  const [isInvoiceFileChange, setIsInvoiceFileChange] = useState(false)
  const [islabelFileChange, setIslabelFileChange] = useState(false)

  const [dialog, setDialog] = useState<string | null>(null)
  const [location, setLocations] = useState<Location | undefined>(undefined)
  const [formData, setFormData] = useState<any>(null)
  const values = getValues()
  const [orderId] = useState<number>(props.match.params.id)
  const [returnStatus, setReturnStatus] = useState<null | string>(
    watch('returnStatus')
  )
  const [order, setOrder] = useState<Order>({})
  const [orderItems, setOrderItems] = useState([])
  const isResend = useRef(useLocation().pathname.split('/')[1])
  const [deliveryTime, setDeliveryTime] = useState<any>('')
  const [locatedInTehran, setLocatedInTehran] = useState(false)
  const [addressDisabled, setAddressDisabled] = useState(false)

  useEffect(() => {
    getOrder({ id: orderId })
    getOrderItems({ 'orderId.equals': orderId, size: 1000 })
  }, [])

  const getCustomerPhoneNumber = watch('customerPhoneNumber')
  const getCustomerZipCode = watch('customerZipCode')

  useEffect(() => {
    if (!isEmpty(order)) {
      const {
        orderType,
        deliveryDate,
        deliveryStartTime,
        deliveryEndTime,
        deliveryType,
        customerName,
        customerAddress,
        customerCity,
        customerNationalCode,
        customerPhoneNumber,
        customerMobileNumber,
        customerProvince,
        customerZipCode,
        trackingCode,
        description,
        fulfillmentWarehouseId,
        fulfillmentTypeId,
        deliveryServiceId,
        courierId,
        centerId,
        cutoffId,
        customerLat,
        customerLon,
        orderTPLType,
        receiptFileName,
        labelFileName
      } = order
      const payload = {
        orderType,
        deliveryDate,
        deliveryStartTime: deliveryDate + ' ' + deliveryStartTime,
        deliveryEndTime: deliveryDate + ' ' + deliveryEndTime,
        // deliveryTime:
        //   deliveryStartTime === '11:00:00'
        //     ? '11-15'
        //     : deliveryStartTime === '16:00:00'
        //       ? '16-20'
        //       : '',
        deliveryTime: null,
        deliveryType,
        customerName,
        customerAddress,
        customerCity,
        customerNationalCode,
        customerPhoneNumber,
        customerProvince,
        customerMobileNumber,
        customerZipCode,
        trackingCode,
        fulfillmentTypeId,
        deliveryServiceId,
        courierId,
        cutoffId,
        orderTplType: orderTPLType ? orderTPLType : 'RONAD',
        description,
        origin: orderType === 'FROM_CENTER' ? centerId : fulfillmentWarehouseId,
        destination: orderType === 'TO_CENTER' ? centerId : null
      }
      setInvoiceFileName(receiptFileName)
      setLabelFile(labelFileName)
      if (order.fulfillmentLineId) {
        setIsFulfillmentService(true)
      }
      const location = {
        lat: Number(customerLat),
        lng: Number(customerLon)
      }
      if (location.lat && location.lng) {
        handleLocations(location)
      }
      reset(payload)
    }
  }, [order])

  useEffect(() => {
    if (addressDisabled) {
      setValue(
        'customerAddress',
        'تهران، محله شادآباد، خیابان ١٧ شهریور، بین شهدای اسلامی و بسیج مستضعفین، شرکت روناد'
      )
      setNotifType('deliveryLocation')
    } else {
      setValue('customerAddress', '')
      setNotifType('')
    }
  }, [addressDisabled])

  useEffect(() => {
    if (locatedInTehran) {
      setValue('customerProvince', 'تهران')
      setValue('customerCity', 'تهران')
    } else {
      setValue('customerAddress', '')
      setValue('customerProvince', '')
      setValue('customerCity', '')
      setNotifType('')
    }
  }, [locatedInTehran])

  useEffect(() => {
    if (getValues('deliveryType') == 'COURIER') {
      setNotifType('COURIER')
    } else {
      setNotifType('')
    }
  }, [getValues('deliveryType')])

  useEffect(() => {
    if (
      values.deliveryDate &&
      checkHourisPast(
        Number(values.deliveryTime?.substring(0, 2)),
        values.deliveryDate
      )
    )
      setValue('deliveryTime', '')
  }, [values.deliveryDate])

  const onSubmit = (data: Inputs) => {
    setFormData(data)
    setDialog('confirmationOrder')
  }

  useEffect(() => {
    const returnStatus = getValues('returnStatus')
    setReturnStatus(returnStatus)
  }, [watch('returnStatus')])

  const handleLocations = (data: { lat: number; lng: number }) => {
    setLocations(data)
  }

  const handleSubmitOrder = async () => {
    try {
      const {
        customerAddress,
        customerCity,
        customerMobileNumber,
        customerName,
        customerNationalCode,
        customerPhoneNumber,
        customerProvince,
        customerZipCode,
        deliveryDate: deliver,
        deliveryType,
        description,
        fulfillmentTypeId,
        deliveryServiceId,
        courierId,
        cutoffId,
        // deliveryTime,
        orderTplType
      } = formData

      const customerInfo = {
        customerCity,
        customerMobileNumber,
        customerName,
        fulfillmentTypeId,
        deliveryServiceId,
        courierId,
        cutoffId,
        customerNationalCode,
        customerPhoneNumber: getCustomerPhoneNumber || '+982177777777',
        customerProvince,
        customerZipCode: getCustomerZipCode || '1111111111',
        deliveryType:
          deliveryType == 'COURIER' && orderTplType == 'EXPRESS_POST'
            ? 'EXPRESS_POST'
            : deliveryType,
        description,
        customerAddress,
        orderTPLType:
          deliveryType == 'COURIER' && orderTplType == 'EXPRESS_POST'
            ? null
            : ['EXPRESS_POST', 'RONAD'].includes(orderTplType)
            ? null
            : orderTplType
      }
      if (deliver.date) {
        var deliveryDate = convertPersianDigit2English(
          deliver.format('YYYY-MM-DD')
        )
      } else {
        var deliveryDate = deliver
      }
      const payload = {
        deliveryDate,
        deliveryStartTime: convertPersianDigit2English(
          deliveryTime.substring(0, 2).concat(':00:00')
        ),
        deliveryEndTime: convertPersianDigit2English(
          deliveryTime.substring(3, 5).concat(':00:00')
        ),
        orderId: orderId
      }
      const body = {
        ...removeEmptyValueObject(payload),
        ...removeEmptyValueObject(customerInfo)
      }

      function callback() {
        history.push('/orders-returned')
      }
      props.resendOrderDispatch({ body, callback })
    } catch (err) {
      if (
        err.response?.status == 400 &&
        err.response.data.fieldErrors.length > 0
      ) {
        err.response.data.fieldErrors.forEach((el) => {
          handleNotification(`مقدار فیلد ${el.field} اشتباه است`, 'error')
        })
      } else if (
        err.response?.status == 406 &&
        err.response.data.errorKey == 'OrderItem.SkuId.not_acceptable'
      ) {
        err.response.data.errorList.forEach((el) => {
          handleNotification(
            `کالا با کد ${el.productCode} و کدتنوع ${el.variantCode} موجود نیست`,
            'error'
          )
        })
      } else if (err.response?.status == 409) {
        handleNotification(`مقدار فیلد کد رهگیری تکراری است`, 'error')
      } else {
        handleError(err)
      }
    }
  }

  const handleReturnToWarehouse = async () => {
    try {
      const { returnStatus } = formData

      props.updateOrderStatusDispatch({
        id: orderId,
        body: { status: returnStatus, description: '' }
      })
      authContext.user.role === 'SELLER_ADMIN'
        ? history.push('seller-orders')
        : history.push('/orders-returned')
    } catch (err) {
      if (
        err.response?.status == 400 &&
        err.response.data.fieldErrors.length > 0
      ) {
        err.response.data.fieldErrors.forEach((el) => {
          handleNotification(`مقدار فیلد ${el.field} اشتباه است`, 'error')
        })
      } else if (
        err.response?.status == 406 &&
        err.response.data.errorKey == 'OrderItem.SkuId.not_acceptable'
      ) {
        err.response.data.errorList.forEach((el) => {
          handleNotification(
            `کالا با کد ${el.productCode} و کدتنوع ${el.variantCode} موجود نیست`,
            'error'
          )
        })
      } else if (err.response?.status == 409) {
        handleNotification(`مقدار فیلد کد رهگیری تکراری است`, 'error')
      } else {
        handleError(err)
      }
    }
  }

  const getOrder = async (payload: any) => {
    try {
      const response = await ordersRepository.getOrderWithId({ payload })
      setOrder(response.data)
    } catch (error) {
      handleError(error)
    }
  }
  const getOrderItems = async (payload: any) => {
    try {
      const response = await ordersRepository.getAllOrderItems({ payload })
      setOrderItems(response.data)
    } catch (error) {
      handleError(error)
    }
  }
  const getOrderFile = async (type: string) => {
    try {
      const response = await getOrderFileReq(orderId, { fileType: type })
      const file = URL.createObjectURL(response.blob)
      return file
    } catch (error: any) {
      handleError(error)
      return error
    }
  }
  const onInvoiceDelete = () => {
    // setInvoiceLink("")
    // setInvoiceFile("")
  }
  const onLabelDelete = () => {
    // setLabelLink("")
    // setLabelFile("")
  }
  const labelFileChange = (e: any) => {
    setLabelFile(e.target.files[0])
    setLabelFileName(e.target.files[0].name)
    setIslabelFileChange(true)
  }
  const invoiceFileChange = (e: any) => {
    setInvoiceFile(e.target.files[0])
    setInvoiceFileName(e.target.files[0].name)
    setIsInvoiceFileChange(true)
  }

  // Components Props
  const orderInfoProps = {
    form,
    cod,
    setCod,
    deliveryLocationType,
    setDeliveryLocationType,
    fulfillmentService: isFulfillmentService,
    setFulfillmentService: setIsFulfillmentService,
    order: order,
    notifType: watch('courierId')
  }

  return (
    <React.Fragment>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid lg={12} md={12} container>
          <Typography
            variant='h6'
            component='h2'
            style={{ fontWeight: 'bold', marginBottom: '24px' }}
          >
            اطلاعات سفارش
          </Typography>
          <Grid md={12} lg={12} item>
            <OrderResendInfo {...orderInfoProps}>
              <OrderResendInputs
                form={form}
                cod={cod}
                setAddressDisabled={setAddressDisabled}
                setLocatedInTehran={setLocatedInTehran}
                setDeliveryTime={setDeliveryTime}
                isFulfillmentService={isFulfillmentService}
                deliveryLocationType={deliveryLocationType}
              />
              <Grid
                container
                item
                md={4}
                spacing={2}
                style={{ marginBottom: '10px' }}
              >
                <Grid item md={6}>
                  <FileWithLink
                    id='invoice'
                    handleChangeFileInput={invoiceFileChange}
                    file={invoiceFile}
                    getFile={() => getOrderFile('RECEIPT')}
                    fileName={invoiceFileName}
                    link={invoiceLink}
                    onClick={() => setDialog('invoiceModal')}
                    lable='افزودن فایل فاکتور (pdf)'
                    onDelete={onInvoiceDelete}
                    disabled
                    accept='.pdf'
                  />
                </Grid>
                <Grid item md={6}>
                  <FileWithLink
                    id='label'
                    handleChangeFileInput={labelFileChange}
                    file={labelFile}
                    getFile={() => getOrderFile('LABEL')}
                    fileName={labelFileName}
                    link={labelLink}
                    // disabled={!isFulfillmentService}
                    disabled
                    onClick={() => setDialog('labelModal')}
                    lable='افزودن لیبل دیجی کالا (pdf)'
                    onDelete={onLabelDelete}
                    accept='.pdf'
                  />
                </Grid>
              </Grid>
            </OrderResendInfo>
          </Grid>
          <Typography
            variant='h6'
            component='h2'
            style={{ fontWeight: 'bold' }}
          >
            اطلاعات ارسال
          </Typography>
          <Grid md={12} lg={12} item>
            <CustomerInfo
              form={{
                errors,
                watch,
                setValue,
                getValues,
                register,
                control
              }}
              cod={cod}
              fulfillmentService={isFulfillmentService}
              deliveryLocationType={deliveryLocationType}
              disableAll={returnStatus !== 'REQUESTED_TO_RESEND'}
              locatedInTehran={locatedInTehran}
              addressDisabled={addressDisabled}
            />
          </Grid>
          <Grid
            xs={12}
            md={12}
            lg={12}
            item
            style={{ marginTop: '-32px', marginBottom: '150px' }}
          >
            <Card className={classes.card} style={{ padding: '10px 0 0 0' }}>
              <CardHeader
                avatar={
                  <Grid>
                    <Typography
                      className={classes.typographyCards}
                      style={{ marginRight: '-25px' }}
                    >
                      لیست کالاها
                    </Typography>
                  </Grid>
                }
              />
              {orderItems?.length > 0 && (
                <CardContent
                  className={classes.cardContentOrder}
                  style={{ padding: '0' }}
                >
                  <Grid style={{ padding: '0', margin: '0' }}>
                    <List data={orderItems} />
                  </Grid>
                </CardContent>
              )}
            </Card>
          </Grid>
          <Grid
            container
            lg={12}
            md={12}
            xs={12}
            spacing={2}
            style={{
              flexDirection: 'row-reverse',
              position: 'fixed',
              backgroundColor: '#D5DADD',
              bottom: '0',
              right: '0',
              padding: '15px',
              zIndex: 2
            }}
          >
            <Grid
              container
              style={{
                // marginLeft: '20px',
                marginTop: '-4px'
              }}
            >
              <Button
                variant='outlined'
                color='primary'
                size='medium'
                onClick={() => window.history.back()}
                style={{
                  marginRight: 'auto'
                }}
                data-cy='cancelCreateOrder'
              >
                {'انصراف'}
              </Button>
              <Button
                type='submit'
                size='medium'
                data-cy='submitAddProduct'
                autoFocus
                variant='contained'
                color='primary'
                style={{
                  marginRight: '14px',
                  marginLeft: '90px'
                }}
                data-cy='saveOrder'
              >
                {'ذخیره تغییرات'}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </form>
      <Dialog
        open={dialog === 'confirmationOrder'}
        onClose={() => setDialog(null)}
        aria-labelledby='responsive-dialog-title'
      >
        <DialogContent>
          <div
            style={{
              position: 'absolute',
              left: '17px',
              zIndex: 10
            }}
          >
            <IconButton aria-label='close' onClick={() => setDialog(null)}>
              <RonadIcons name='times' size={0.8} />
            </IconButton>
          </div>

          <div className={classes.cancelTitle}>
            <Typography variant={'h6'}>
              {`آیا از تعیین وضعیت سفارش ${orderId} مطمئن هستید؟`}
            </Typography>
          </div>
          <Divider style={{ marginBottom: '10px' }} />
        </DialogContent>
        <DialogActions className={classes.actionsBox}>
          <Grid container spacing={2}>
            <Grid
              item
              xs={12}
              spacing={2}
              style={{ padding: '5px 0', marginBottom: '8px' }}
            >
              <Button
                style={{ margin: '7px', padding: '5px 30px' }}
                autoFocus
                onClick={() => setDialog(null)}
                variant='outlined'
                color='primary'
                size='medium'
                data-cy='cancel'
              >
                {'انصراف'}
              </Button>
              <Button
                style={{ margin: '7px' }}
                variant='contained'
                onClick={
                  returnStatus === 'REQUESTED_TO_RESEND'
                    ? handleSubmitOrder
                    : handleReturnToWarehouse
                }
                size='medium'
                color='primary'
                data-cy='saveBtn'
              >
                {'ذخیره تغییرات'}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  )
}

const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  orderItemsList: makeSelectAllOrderItems(),
  order: makeSelectOrder(),
  count: makeSelectCountList(),
  loading: makeSelectLoading(),
  error: makeSelectError()
})

function mapDispatchToProps(dispatch: Function) {
  return {
    createParcelsDispatch: (payload: PayloadCreate) =>
      dispatch(createParcelsActions(payload)),
    getOrderDispatch: (payload: { id: number }) =>
      dispatch(getOrderWithIdAction(payload)),
    getOrderItemsDispatch: (payload: any) =>
      dispatch(getAllOrderItemsAction(payload)),
    clearOrderDispatch: () => dispatch(clearOrderAction()),
    createOrderItemDispatch: (payload: createOrderItemsPayload) => {
      dispatch(createOrderItemsAction(payload))
    },
    resendOrderDispatch: (payload: UpdateOrderPayload) => {
      dispatch(resendOrdersAction(payload))
    },
    updateOrderStatusDispatch: (payload: {
      id: number
      body: string
      pagination: object
    }) => dispatch(updateOrderStatusActions(payload))
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)
export default compose(withConnect)(ResendOrder)
